import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.tomatoRed
};
export default anchor;